<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <form @submit.prevent="saveSnapshot()">
          <div class="modal-container child">
            <div class="modal-header"><h3>Save Snapshot</h3></div>
            <div class="modal-body">
              <div class="form-group row">
                <div
                  :class="{
                    'has-error':
                      hasErrors && setName === null,
                  }"
                  class="col-xs-6">
                  <label for="snapshotTitle">Snapshot Title</label>
                  <input
                    id="snapshotTitle"
                    v-model="snapshotTitle"
                    name="snapshotTitle"
                    type="text"
                    class="form-control">
                </div>
              </div>
              <div
                v-if="hasErrors && !isValid"
                class="alert alert-danger"
                role="alert">
                <button
                  type="button"
                  class="close"
                  @click="hasErrors = false">
                  <span aria-hidden="true">×</span>
                </button>
                <p>Please fil in the mandatory fields.</p>
              </div>
              <div class="alert alert-info" role="alert">
                <p>
                  It may take several minutes, please wait for
                  the completion.
                </p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                :disabled="clickedProceed"
                type="submit"
                class="btn btn-primary">
                Proceed
              </button>
              <button
                type="button"
                class="modal-default-button btn btn-default"
                @click="$emit('close')">
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '../services/eventBus.js';

export default {
	data() {
		return {
			snapshotTitle: '',
			clickedProceed: false,
			hasErrors: false,
		};
	},
	computed: {
		isValid() {
			return this.snapshotTitle !== '' && this.snapshotTitle !== null;
		},
	},
	methods: {
		saveSnapshot() {
			if (this.snapshotTitle === '') {
				this.hasErrors = true;
			} else {
				this.clickedProceed = true;
				this.hasErrors = false;
				EventBus.$emit('saveSnapshot', this.snapshotTitle);
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalSaveSnapshot.vue